import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  ViewChild
} from '@angular/core';
import { ThemeColorService } from '@epsilon/core-ui';

@Component({
    selector: 'lib-audience-ai-preview',
    templateUrl: './audience-ai-preview.component.html',
    styleUrl: './audience-ai-preview.component.sass',
    standalone: false
})
export class AudienceAiPreviewComponent implements OnChanges {
  @ViewChild('previewContent') private previewContainer!: ElementRef;

  @Input() previewData!: any;
  @Input() count!: string;

  @Output() previewContent = new EventEmitter<ElementRef>();
  @Output() previewCollapsed = new EventEmitter<boolean>();

  currentTheme: number;
  hidePreview = false;

  constructor(private themeColorService: ThemeColorService) {
    themeColorService.getThemeMap().subscribe(() => {
      this.currentTheme = this.themeColorService.getTheme();
    });
  }

  ngOnChanges(): void {
    setTimeout(() => {
      this.previewContent.emit(this.previewContainer);
    });
  }

  public get audienceAIFormGroupPreviewDataHasSomeValues(): boolean {
    const controls = Object.keys(this.previewData);
    return controls.length && controls.some((c) => this.previewData[c]?.length);
  }

  public addSQLTags(sql: string) {
    return '```sql\n' + sql + '\n```';
  }

  public togglePreviewPanel() {
    this.hidePreview = !this.hidePreview;
    this.previewCollapsed.emit(this.hidePreview);
  }

  public copyToClipboard(): void {
    navigator.clipboard.writeText(this.previewData.audience_query);
  }
}
